const TradingPairSelector = ({ selectedPair, onSelectPair }) => {
  const pairs = [
    { symbol: 'BTC', name: 'Bitcoin', color: 'text-orange-400', pair: 'BTC/USDT', price: 43250.50 },
    { symbol: 'ETH', name: 'Ethereum', color: 'text-blue-400', pair: 'ETH/USDT', price: 2280.75 },
    { symbol: 'BNB', name: 'Binance', color: 'text-yellow-400', pair: 'BNB/USDT', price: 312.40 },
    { symbol: 'SOL', name: 'Solana', color: 'text-purple-400', pair: 'SOL/USDT', price: 98.20 },
    { symbol: 'XRP', name: 'Ripple', color: 'text-blue-300', pair: 'XRP/USDT', price: 0.6234 },
    { symbol: 'ADA', name: 'Cardano', color: 'text-blue-500', pair: 'ADA/USDT', price: 0.4821 },
  ];

  return (
    <div className="glow-card p-4 sm:p-6 rounded-xl">
      <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Select Trading Pair</h3>
      <div className="space-y-3 max-h-[400px] sm:max-h-[500px] overflow-y-auto pr-2 custom-scrollbar">
        {pairs.map((item) => (
          <button
            key={item.pair}
            onClick={() => onSelectPair(item)}
            className={`w-full p-4 rounded-lg transition-all text-left ${
              selectedPair === item.pair
                ? 'bg-gradient-to-r from-purple-600 to-purple-800 shadow-lg'
                : 'bg-gray-800/50 hover:bg-gray-800'
            }`}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className={`text-2xl font-bold ${item.color} mb-1`}>
                  {item.symbol}
                </div>
                <div className="text-sm text-gray-400">{item.name}</div>
              </div>
              <div className="text-right">
                <div className="text-lg font-bold text-white">${item.price.toLocaleString()}</div>
                <div className="text-xs text-gray-400">USDT</div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TradingPairSelector;
